

import { ConfigService } from '../../core/services/config.service';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

/**
 * @export
 * @class LocoIncidentService
 */
@Injectable()
export class LocoIncidentService {
    private configData: any;
    private apiUrl: string;
    private RESOURCE_URL = '/locomotives/';


    constructor(private configService: ConfigService, private http: HttpClient) {
        this.configData = this.configService.getConfigData();
        this.apiUrl = this.configData.urls.API_URL;
    }

    getData(locoId: Array<string>) {
        const apiUrl = this.configData.urls.API_URL;
        let headers = new HttpHeaders();
        headers = headers.append('Content-Type', 'application/json');
        const options = { headers: headers };
        return this.http.post(`${apiUrl}${this.RESOURCE_URL}locoIncident`, JSON.stringify(locoId), options);
    }
}
